import { useState, useCallback } from "react";

export default () => {
  const [user, setUser] = useState<API.CurrentUser>({} as API.CurrentUser);
  const [permissionTree, setPermissionTree] = useState<string[]>([]);

  const setUserInfo = useCallback((info: API.CurrentUser) => {
    setUser(info);
  }, []);

  const setPermission = useCallback((permissions: string[]) => {
    setPermissionTree(permissions);
  }, []);

  const clearUser = useCallback(() => {
    setUser({} as API.CurrentUser);
    setPermissionTree([]);
  }, []);

  // user: {
  // "id": "1981282759034847235",
  // "nickname": "超级管理员",
  // "account": "admin",
  // "token": "15a7bab9-8e20-49cf-b4b0-36e1e1b8554c",
  // "tokenTimeout": "2592000",
  // "adminFlag": 1,
  // "roleList": [
  //     {
  //         "id": "1981282759034847238",
  //         "name": "超级管理员",
  //         "code": "surper_admin",
  //         "adminFlag": 1
  //     }
  // ],
  // "forceResetPwd": 1,
  // "pwdUpdateTime": "2026-03-04 14:18:55",
  // "permissionTree": [
  //     {
  //         "id": "1981282759034847250",
  //         "name": "用户管理",
  //         "route": "user-management",
  //         "icon": null,
  //         "parentId": "0",
  //         "type": "1",
  //         "perm": "user.management",
  //         "sort": 1,
  //         "children": null
  //     },
  //     {
  //         "id": "1981282759034847251",
  //         "name": "角色管理",
  //         "route": "role-management",
  //         "icon": null,
  //         "parentId": "0",
  //         "type": "1",
  //         "perm": "role.management",
  //         "sort": 2,
  //         "children": null
  //     }
  // ]
  // }

  return {
    user,
    setUserInfo,
    permissionTree,
    setPermission,
    clearUser,
  };
};
